<template>
  <div>
    <page-header :title="$t('scope.text_293')" />
    <page-body>
      <voucher-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import VoucherManagerList from './components/List'

export default {
  name: 'VoucherManagerIndex',
  components: {
    VoucherManagerList,
  },
  data () {
    return {
      listId: 'voucher-manager-list',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
